import firebase from 'firebase/compat/app';
import 'firebase/compat/analytics';

import store from '@state/store';

/**
 * Send Firebase Event
 *
 * @param { String } eventName
 * @param { Object } optionalParams
 * @returns null
 */
export default function sendEvent(eventName = 'RS_event', optionalParams) {
  let user = store.getters['auth/user'];

  if (!user) return;

  let defaultParams = {
    name: user.name,
    email: user.email,
    number: user.number,
    resto_id: user.resto_id,
    resto_name: user.restuarant_name,
  };

  const params = { ...defaultParams, ...optionalParams };

  // Log firebase event
  firebase.analytics().logEvent(eventName, params);
}
